module.exports = __webpack_public_path__ + "img/mm.0f7aae29.jpg";